const months = {
    se: [
        'Januari',
        'Februari',
        'Mars',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'Augusti',
        'September',
        'Oktober',
        'November',
        'December',
    ],
};
const weekdaysLong = {
    se: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
};
const weekdaysShort = { se: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'] };

export { months, weekdaysLong, weekdaysShort };
